import { my_routes } from "../router/all_routes";
import { Link } from "react-router-dom";
import { useParams } from "react-router";
import {
  Action,
  buildPermission,
  Resource,
} from "../../core/common/autorisations/permissionsMap";
import withPermission from "../../core/common/autorisations/withPermission";

//  bouton protégée pour modifier un etudiant/inscription
const ProtectedUpdateStudent = withPermission(
  (props: any) => (
    <Link
      to={`/edit-student/${props.id}`}
      className="btn btn-primary d-flex align-items-center mb-2"
    >
      <i className="ti ti-edit-circle me-2" />
      Modifier Etudiant
    </Link>
  ),
  [buildPermission(Resource.STUDENT, Action.UPDATE)],
  "masquer",
);

const StudentBreadcrumb = () => {
  const routes = my_routes;
  const { id } = useParams(); // On récupère l'id de l'URL

  return (
    <div className="col-md-12">
      <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
        <div className="my-auto mb-2">
          <h3 className="page-title mb-1">Details Etudiant</h3>
          <nav>
            <ol className="breadcrumb mb-0">
              <li className="breadcrumb-item">
                <Link to={routes.adminDashboard}>Dashboard</Link>
              </li>
              <li className="breadcrumb-item">
                <Link to={routes.allStudent}>Etudiants</Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Details Etudiant
              </li>
            </ol>
          </nav>
        </div>
        <div className="d-flex my-xl-auto right-content align-items-center  flex-wrap">
          <ProtectedUpdateStudent id={id} />
        </div>
      </div>
    </div>
  );
};

export default StudentBreadcrumb;
